import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dailyRate',
  templateUrl: './dailyRate.component.html',
  styleUrls: ['./dailyRate.component.scss']
})

export class DailyRateComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;

  pdpmData: any;

  finalDailyRate = '';
  projection30Day = '';
  projection100Day = '';

  wageAdjustedBase = '';
  totalNtaAddOn = '';
  pdpmTotal = '';
  combinedRate = '';
  afterAdjustments = '';

  urbanDailyRate = '';
  ruralDailyRate = '';
  ruralAddOn = '';
  difference = '';
  totalDailyRate = '';
  finalDailyPatientRate  = '';
  totalNTAAddOn  = '';

  constructor(public dialogRef: MatDialogRef<DailyRateComponent>,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  
  }

  ngOnInit(): void {

    // Parse only if pdpmData is a string
    this.pdpmData = typeof this.data.pdpmData === 'string'
      ? JSON.parse(this.data.pdpmData)
      : this.data.pdpmData;

    const rates = this.pdpmData?.PDPMRates;//this.pdpmData?.Stats?.Rates;

    if (rates) {

      this.finalDailyRate = rates.FinalDailyPatientRate ?? '$0.00';
      this.projection30Day = rates['Projection30Day'] ?? '$0.00';
      this.projection100Day = rates['Projection100Day'] ?? '$0.00';

      this.wageAdjustedBase = rates.WageAdjustedBase ?? '$0.00';
      this.totalNtaAddOn = rates.TotalNTAAddOnDays1To3 ?? '$0.00';
      this.pdpmTotal = rates.PDPMTotal ?? '$0.00';
      this.combinedRate = rates.CombinedRate ?? '$0.00';
      this.afterAdjustments = rates.AfterAdjustments ?? '$0.00';

      this.urbanDailyRate = rates.UrbanDailyRate ?? '$0.00';
      this.ruralDailyRate = rates.RuralDailyRate ?? '$0.00';
      this.ruralAddOn = rates.RuralAddOnIfAny ?? '$0.00';
      this.difference = rates.Difference ?? '$0.00';
      this.totalDailyRate = rates.TotalDailyRateDays4Plus ?? '$0.00';

      this.finalDailyPatientRate = rates.FinalDailyPatientRate ?? '$0.00';
      this.totalNTAAddOn = rates.TotalNTAAddOnDays1To3 ?? '$0.00';
    }
  }

  closePopUp() {
    this.dialogRef.close();
  }

}
